export const HORARIOS_TEST_DRIVE = [9, 10, 11, 12, 13, 14, 15, 16].map((h) => ({
  value: `${h} hs`,
  label: `${h} hs`,
}));

// Constantes legacy (formularios viejos no activos en esta landing)
export const HORARIOS = [];
export const ESTADIOS = [];
export const OPCIONES_INSCRIPCION = [];
export const SEDE_FIAT = "";
export const DIRECCION_FIAT = "";
export const LEYENDA_SEDE_FIAT = "";
export const getHorarioLabel = (value) => value;
export const getEstadio = () => undefined;
